import React, { useState, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import { CSVLink } from "react-csv";
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';

const TrainDownload = (props) => {
    /*const [values, setValues] = useState({
        startDate: '',
        endDate: moment().format('YYYYMMDD')
    });*/
    const [bookingData, setBookingData] = useState(null);
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [csvData, setCsvData] = useState(null);
    const { addToast } = useToasts();
    const csvRef = useRef();
    const [searchflag, setSearchFlag] = useState(false);

    const BookSearch = async () => {
        const jwt = localStorage.getItem('jwt');
        const reg_params = {
            "operator": "and",
            "where": [
                {
                    "operator": "gte",
                    "attr": "book_date",
                    "val": moment(startDate).format('YYYY-MM-DD')
                },
                {
                    "operator": "lte",
                    "attr": "book_date",
                    "val": moment(endDate).format('YYYY-MM-DD')
                },
                {
                    "operator": "eq",
                    "attr": "site_id",
                    "val": props.siteId
                },
            ]
        };
        var params = {};
        params = {
            "operator": "and",
            "where": [
                { "site_id": props.siteId },
            ]
        }

        // DB取得
        const booking_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/train_booking/search/all`, reg_params, {
            headers: {
                Authorization: `Bearer ${jwt}`,
            }
        })).data;
        const ticketdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/search/`, params, { headers: { Authorization: `Bearer ${jwt}` } })).data;
        booking_data.sort((a, b) => a.book_date > b.book_date ? 1 : (a.book_date === b.book_date && a.book_id > b.book_id) ? 1 : (a.book_date === b.book_date && a.book_id === b.book_id && a.book_no > b.book_no) ? 1 : -1);

        setSearchFlag(true);
        setBookingData(booking_data);
        CreateCsvData(booking_data, ticketdata);
    }

    const CreateCsvData = (data, ticketdata) => {
        const filteredData = data.filter(p =>
            p.status !== 'UPAY' &&
            p.status !== 'CUPAY' &&
            moment(p.book_date).isBetween(startDate, endDate, null, '[]')
        );

        var list = [];
        var head = [];
        head.push({ label: "乗車日", key: "book_date" });
        head.push({ label: "No", key: "book_id" });
        head.push({ label: "利用者ID", key: "customer_id" });
        head.push({ label: "性別", key: "gender" });
        head.push({ label: "生年月日", key: "birth" });
        head.push({ label: "郵便番号", key: "postal_code" });
        head.push({ label: "最寄り駅", key: "stationInfo" });
        head.push({ label: "nimoca番号", key: "card_no" });
        head.push({ label: "チケット", key: "ticket_name" });
        head.push({ label: "人数", key: "count" });
        head.push({ label: "乗車駅", key: "entry_name" });
        head.push({ label: "降車駅", key: "entry_name2" });
        head.push({ label: "予約時刻", key: "booking_date" });
        head.push({ label: "料金", key: "total" });
        head.push({ label: "キャンセル料", key: "fee" });
        head.push({ label: "払い戻し額", key: "refund_total" });
        head.push({ label: "払い戻し時刻", key: "refund_date" });
        head.push({ label: "決済金額", key: "subtotal" });
        head.push({ label: "決済手段", key: "payment_type" });
        head.push({ label: "ステータス", key: "status" });

        filteredData.forEach(p => {
            const p2 = filteredData.filter(x => x.book_id === p.book_id && constClass.STATUS.CFIN === x.status).sort((a, b) => b.book_no - a.book_no);
            const refund = constClass.STATUS.CCL === p.status ? p.total : p2.length >= 1 && p2[0].book_no === p.book_no ? Number(p.refund_total) : "";
            var booking = {
                book_date: moment(p.book_date).format("YYYY/MM/DD"),
                book_id: p.book_id,
                customer_id: p.customer_id,
                gender: p.gender === "1" ? "男性" : p.gender === "2" ? "女性" : p.gender === "3" ? "その他" : "",
                birth: moment(p.birth).format("YYYY/MM/DD"),
                postal_code: `${p.postal_code.substring(0, 3)}-${p.postal_code.substring(3)}`,
                stationInfo: p.t_customer_detail.find(q => q.entry_name).entry_name,
                card_no: p.card_no,
                ticket_name: ticketdata.find(x => x.ticket_id === Number(p.ticket_id)).ticket_name,
                count: `${p.count}人`,
                entry_name: (() => {
                    const ticket = ticketdata.find(t => t.ticket_id === Number(p.ticket_id));
                    let foundDetail = null;
                    for (const x of ticket.ticket_detail_data) {
                        const ticketIdMatch = x.ticket_id === Number(p.ticket_id);
                        const bookingDetailMatch = p.t_booking_detail && p.t_booking_detail.find(b => b.entry_type === "E01" && b.entry_data === x.entry_data);
                        if (ticketIdMatch && bookingDetailMatch) {
                            foundDetail = x;
                            break;
                        }
                    }
                    return foundDetail.entry_name;
                })(),
                entry_name2: (() => {
                    const ticket = ticketdata.find(t => t.ticket_id === Number(p.ticket_id));
                    let foundDetail = null;
                    for (const x of ticket.ticket_detail_data) {
                        const ticketIdMatch = x.ticket_id === Number(p.ticket_id);
                        const bookingDetailMatch = p.t_booking_detail && p.t_booking_detail.find(b => b.entry_type === "E02" && b.entry_data === x.entry_data);
                        if (ticketIdMatch && bookingDetailMatch) {
                            foundDetail = x;
                            break;
                        }
                    }
                    if (!foundDetail) return '詳細データなし';
                    return foundDetail.entry_name;
                })(),
                booking_date: moment(p.ins_date).format("YYYY年M月D日 H時m分"),
                total: p.total,
                refund_total: p.refund_total ? p.refund_total : 0,
                refund_date: moment(([...new Set(p.booking_t_payment.filter(t => Number(t.transaction_id) === Number(p.book_id)).map(a => a.upd_date))].pop())).format("YYYY年M月D日 H時m分"),
                fee: p.refund_total ? Number(p.total) - Number(p.refund_total) : 0,
                subtotal: p.refund_total ? Number(p.total) - Number(p.refund_total) : p.total,
                refund: refund,
                payment_type: ((last => last === 'credit' ? 'クレジットカード' : last === 'paypay' ? 'PayPay' : last)([...new Set(p.booking_t_payment.filter(t => Number(t.transaction_id) === Number(p.book_id)).map(a => a.payment_type))].pop())),
                status: constClass.STATUS_NAME_CSV[p.status],
                ins_date: moment(p.ins_date).format("YYYY/MM/DD HH:mm:ss"),
            };
            list.push(booking);
        });
        setCsvData({ header: head, list: list });
    }

    // 検索ボタン
    const searchButton = () => {
        return (
            <button type="button"
                className={`btn btn-primary mx-5`}
                onClick={() => BookSearch()}>
                検索
            </button>
        )
    }

    const dateChange = (event) => {
        // 開始日
        if (event.target.name === "book_date_start") {
            const newStartDate = event.target.value;
            const diffDays = moment(endDate).diff(moment(newStartDate), 'days');

            if (diffDays > 60) {
                addToast('開始日と終了日の差は60日以内にしてください。', { appearance: 'error', autoDismiss: true });
                return;
            }

            setStartDate(newStartDate);

            // 終了日
        } else if (event.target.name === "book_date_end") {
            const newEndDate = event.target.value;
            const diffDays = moment(newEndDate).diff(moment(startDate), 'days');

            if (diffDays > 60) {
                addToast('開始日と終了日の差は60日以内にしてください。', { appearance: 'error', autoDismiss: true });
                return;
            }

            setEndDate(newEndDate);
        }
    }

    const handleExportClick = async () => {
        const jwt = localStorage.getItem('jwt');
        const params = {
            site_id: props.siteId,
            command: 'booking_csv_export',
            book_id: csvData.list.map(b => b.book_id)
        }
        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/log/`, params, {
                headers: {
                    Authorization: `Bearer ${jwt}`
                }
            });

            csvRef.current.link.click();
        } catch (err) {
            if (err.response.data !== null) {
                addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
            } else {
                addToast(err.response, { appearance: 'error', autoDismiss: true });
            }
        } finally {
        }
    }

    const renderList = () => {
        return (
            <div className="pt-1 pb-2">
                <div className="col-2 text-center"></div>
                <div className="row mb-3 p-0">
                    <div className="col-2">
                        <div className="d-flex align-items-center justify-content-center pt-2">
                            乗車日：
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="col-sm-12 csv-input">
                            <input type="date" className="form-control" id={"book_date_start"} name={"book_date_start"} value={moment(startDate).format('YYYY-MM-DD')} onChange={dateChange}></input>
                        </div>
                    </div>
                    <div className="col-1">
                        <div className="d-flex align-items-center justify-content-center pt-2">
                            ～
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="col-sm-12">
                            <input type="date" className="form-control" id={"book_date_end"} name={"book_date_end"} value={moment(endDate).format('YYYY-MM-DD')} onChange={dateChange}></input>
                        </div>
                    </div>
                    {/* 検索ボタン */}
                    <div className="col-3">
                        <div className="col-sm-12">
                            {searchButton()}
                        </div>
                    </div>
                </div>
                {searchflag &&
                    <div className="col-11 d-flex justify-content-center align-items-center mb-4">
                        <table className="col-5 table table-bordered text-center" height="1">
                            <thead>
                                <tr>
                                    <th className='align-middle'>検索件数</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center">
                                        {bookingData ? bookingData.filter(a => a.status !== 'UPAY' && a.status !== 'CUPAY' && moment(a.book_date).isBetween(startDate, endDate, null, '[]')).length : ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }
                <div className="row btn-toolbar">
                    <div className="btn-group col-11">
                        <div className="offset-4 col-4">
                            {csvData !== null && (
                                <React.Fragment>
                                    <button
                                        className="btn btn-primary print-none mb-1 px-0 w-100"
                                        onClick={() => handleExportClick()}>
                                        予約データ出力
                                    </button>
                                    <CSVLink className="d-none" data={csvData.list} headers={csvData.header} filename={"予約データ" + moment(startDate).format('YYYY年MM月DD日') + "～" + moment(endDate).format('YYYY年MM月DD日') + ".csv"} ref={csvRef} />
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="container">
            {renderList()}
        </div>
    );
}

export default TrainDownload;